var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.074 30.553"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".instagram_svg__a{fill:none;stroke:#1e2022;stroke-linecap:square;stroke-miterlimit:10;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.036 1.035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 27 26-1M2 28 1 0M0 1l27 1M26 1l-.5 27.5",
    className: "instagram_svg__a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    className: "instagram_svg__a",
    rx: 4,
    transform: "translate(5.5 6.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    className: "instagram_svg__a",
    transform: "translate(10.5 11.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    className: "instagram_svg__a",
    transform: "translate(17.5 9.5)"
  }))));
};
export default SvgInstagram;